import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
export const getStylesForVariant = (variant) => {
    const styleVariantMap = {
        h1: {
            fontSize: "31px",
            lineHeight: "42px",
            fontWeight: "400",
        },
        h2: {
            fontSize: "25px",
            lineHeight: "34px",
            fontWeight: "400",
        },
        h3: {
            fontSize: "20px",
            lineHeight: "27px",
            fontWeight: "600",
        },
        h4: {
            fontSize: "16px",
            lineHeight: "22px",
            fontWeight: "700",
        },
        body0: {
            fontSize: "10px",
            lineHeight: "14px",
            fontWeight: "400",
        },
        body1: {
            fontSize: "13px",
            lineHeight: "18px",
            fontWeight: "400",
        },
        body2: {
            fontSize: "16px",
            lineHeight: "22px",
            fontWeight: "400",
        },
        body3: {
            fontSize: "20px",
            lineHeight: "27px",
            fontWeight: "400",
        },
    };
    return styleVariantMap[variant];
};
const BryxTypography = styled(({ children, variant, noWrap, ...props }) => {
    return (_jsx(Typography, { variant: variant, noWrap: noWrap ? true : false, ...props, children: children }));
})(({ variant }) => {
    return {
        ...getStylesForVariant(variant),
    };
});
export default BryxTypography;
